/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InboxThreadListItem } from './inboxThreadListItem';
import type { TabCounts } from './tabCounts';

/**
 * ``GET /inbox/threads`` response envelope.
 */
export interface InboxThreadListResponse {
  items: InboxThreadListItem[];
  next_cursor?: string | null;
  tab_counts: TabCounts;
}
